import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/human-futures")({
  head: () => ({
    meta: [
      { title: pageTitle("Human Futures", "en") },
      { name: "description", content: "Essays on the futures we choose, inherit and abandon — and what it means to be human in them." },
      { property: "og:title", content: "Human Futures — Smart Sustainability" },
      { property: "og:description", content: "Essays on humans and the futures ahead." },
      { property: "og:url", content: "https://smartsustainability.ai/human-futures" },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "tr_TR" },
    ],
    links: [
      { rel: "canonical", href: "https://smartsustainability.ai/human-futures" },
      ...hreflangLinks("/insan-ve-gelecek", "/human-futures"),
    ],
  }),
  loader: () => getAllPosts(),
  component: HumanFuturesPage,
});

function HumanFuturesPage() {
  const { t } = useT();
  const { articles: posts } = useLocalizedPosts(Route.useLoaderData());
  return (
    <CategoryPage
      category={t("cat.human.title")}
      tagline={t("cat.human.tagline")}
      essays={posts.filter((p) => String(p.category) === "Human Futures" || String(p.category) === "İnsan ve Gelecek")}
    />
  );
}
